import { render, staticRenderFns } from "./newlyCompany.vue?vue&type=template&id=d4826c58&scoped=true"
import script from "./newlyCompany.vue?vue&type=script&lang=js"
export * from "./newlyCompany.vue?vue&type=script&lang=js"
import style0 from "./newlyCompany.vue?vue&type=style&index=0&id=d4826c58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4826c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4826c58')) {
      api.createRecord('d4826c58', component.options)
    } else {
      api.reload('d4826c58', component.options)
    }
    module.hot.accept("./newlyCompany.vue?vue&type=template&id=d4826c58&scoped=true", function () {
      api.rerender('d4826c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/newlyCompany.vue"
export default component.exports